import axios from 'axios';
import store from '../store/index'
import Point from './Point'
import router from '../router/index'

// eslint-disable-next-line no-unused-vars
let baseURL;
if (process.env.NODE_ENV === 'development') { // 开发环境
  baseURL = '/api';
}
export const BSURL={
    development:'http://legal.hikoon.channel'
}
const Axios = axios.create({
  baseURL, // 后台服务地址
  timeout: 6000, // 请求时间
//   withCredentials: false,
});
// 请求拦截器
Axios.interceptors.request.use(function(config ){
  if(store.state.access_token){
    config.headers['Authorization'] ='Bearer '+store.state.access_token
    
  }
  return config
},function(err){
    return Promise.reject(err)
})
// 相应拦截器
Axios.interceptors.response.use(
    response=>{
        // response
        if(response.status===200&&response.data.code===401){
            store.commit('loginOut');
            Point('登录已超时，请重新登录。')
            router.push('/login')
        }
          return response
        },
        // 接口错误状态处理，也就是说无响应时的处理
        error => {
          return Promise.reject(error.response.status) // 返回接口返回的错误信息
        
    }
)
export default Axios;



// WEBPACK FOOTER //
// ./src/utils/request.js